import { GenderEnum } from 'src/app/models/enums/gender-enum';

export function getGenderFromPesel(pesel: string) {
  if (!pesel || pesel.length !== 11) return null;
  return +pesel.slice(-2, -1) % 2 == 0 ? GenderEnum.Female : GenderEnum.Male;
}
